//Função Clique do Frete
$(document).on("click","#calculoFrete",function (e){
   e.preventDefault();
   //abreModalFrete
   $("#ModalFrete").removeClass("oculto");
});

$(document).on("click","#closeBtnModalFrete",function (e){
   e.preventDefault();
   $("#ModalFrete").addClass("oculto");
});

/*Clique no botão de Click*/
$(document).on("click","#btnConsultarFrete",function (e){
   e.preventDefault();
   calculaFrete();

});
//Fim Função Clique do Frete


/*Função de Cáculo de Frete*/
function calculaFrete() {
   const cepInput = document.getElementById('txtCEP');
   let cepValue = cepInput.value;

   if (cepValue === '' || cepValue.length < 9) {
      alert('Por favor, preencha o CEP corretamente.');
      return;
   }

   const infosProdutos = getInfosProdutos();
   cepValue = cepValue.replace(/-/g, "");

   const btnConsulta = document.getElementById("btnConsultarFrete");
   btnConsulta.classList.add('loadingButton');

   const fetchFrete = (pesoMerc, vlrMerc, services) => {
      const params = new URLSearchParams({
         cepOrigem:    "05433040",
         cepDestino:   cepValue,
         vlrMerc:      vlrMerc,
         pesoMerc:     pesoMerc,
         largura:      JSON.stringify(infosProdutos['largura']),
         altura:       JSON.stringify(infosProdutos['altura']),
         comprimento:  JSON.stringify(infosProdutos['comprimento']),
         services:     services
      });
      //return fetch("https://algohits.com/melhor-envio", {
      return fetch("https://be1581b982c8411181871760405582648.1531958.meusitehostgator.com.br/scripts/page-melhor-envio.php", {
         method: "POST",
         headers: { "Content-Type": "application/x-www-form-urlencoded" },
         body: params.toString()
      }).then(res => res.json());
   };

   // Chamada 1: SEDEX + Express (1,2,31) — peso 0.3kg, seguro = valor do produto
   // Chamada 2: JeT (33) — peso 0.65kg, seguro fixo R$ 87,90
   Promise.all([
      fetchFrete(0.3, infosProdutos['valorTotal'], "1,2,31"),
      fetchFrete(0.650, 87.90, "33")
   ])
      .then(([resultCorreios, resultExpress]) => {
         btnConsulta.classList.remove('loadingButton');

         // Correios tem prioridade: serviços que já vieram na chamada 1
         // não são repetidos com o preço da chamada 2 (ex: se SEDEX vier nas duas)
         const idsCorreios = new Set((Array.isArray(resultCorreios) ? resultCorreios : []).map(i => i.referencia));
         const expressExtra  = (Array.isArray(resultExpress) ? resultExpress : []).filter(i => !idsCorreios.has(i.referencia));

         const resultadoFinal = [
            ...(Array.isArray(resultCorreios) ? resultCorreios : []),
            ...expressExtra
         ];

         if (resultadoFinal.length > 0) {
            const tableRows = resultadoFinal.map(item => `
               <tr id="${item.referencia}">
                  <td><span>${item.transp_nome}</span>${item.descricao}</td>
                  <td>${floatToCurrency(item.vlrFrete)}</td>
                  <td>Em até ${item.prazoEnt} dias úteis.</td>
               </tr>
            `).join('');

            MostraRespostaFrete(`
               <div class="resposta-sucesso">
                  <div class="containerResposta">
                     <table class="tabelaResultados">
                        <thead>
                           <tr>
                              <th>Tipo</th>
                              <th>Preço</th>
                              <th>Estimativa</th>
                           </tr>
                        </thead>
                        <tbody>${tableRows}</tbody>
                     </table>
                     <div class="btnVoltarFrete" onClick="btnVoltarFrete()">Voltar</div>
                  </div>
               </div>
            `);
         } else {
            MostraRespostaFrete(`
               <div class="resposta-erro">
                  <div class="containerResposta">
                     <p>Nenhuma opção de frete disponível. Por favor, tente novamente.</p>
                     <div class="btnVoltarFrete" onClick="btnVoltarFrete()">Voltar</div>
                  </div>
               </div>
            `);
         }
      })
      .catch(() => {
         btnConsulta.classList.remove('loadingButton');
         MostraRespostaFrete(`
            <div class="resposta-erro">
               <div class="containerResposta">
                  <p>Falha ao retornar a estimativa de frete. Por favor, tente novamente.</p>
                  <div class="btnVoltarFrete" onClick="btnVoltarFrete()">Voltar</div>
               </div>
            </div>
         `);
      });
}

/*Funcões Extra para caáulo do frete*/
   function floatToCurrency($valor){
      return $valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
   }

   function MostraRespostaFrete(htmlToShow){
      caixaForm = document.getElementById("inputSimulador");
      caixaForm.classList.add('oculto');

      caixaResult = document.getElementById("resultSimulador");

      caixaResult.innerHTML = htmlToShow;
      caixaResult.classList.remove('oculto');
   }

   function btnVoltarFrete(){
      caixaResult.innerHTML = "";
      caixaResult.classList.add('oculto');
      caixaForm = document.getElementById("inputSimulador");
      caixaForm.classList.remove('oculto');
   }


function getInfosProdutos(){
   var productInfos = [];

   productInfos['valorTotal'] = 0;
   productInfos['pesoTotal'] = 0;
   productInfos['volumes'] = [];
   productInfos['produtos'] = [];

   // CORREÇÃO: usar querySelector ao invés de querySelectorAll
   const row = document.querySelector('.informacoes-para-frete-row');

   if (row) {
      //Valor do Produto e Quantidade
      inputQtd = 1;
      precoUnitario = formatToNum(row,'.tamanho-detalhes .variant-price');
      inputValorTotalProduto = inputQtd * precoUnitario;

      //Peso
      pesoProdutoUnitario = formatToNum(row,'.tamanho-detalhes .item_peso');
      pesoTotalProduto = inputQtd * pesoProdutoUnitario;

      //Altura
      alturaProdutoUnitario = formatToNum(row,'.tamanho-detalhes .item_altura');

      //Largura
      larguraProdutoUnitario = formatToNum(row,'.tamanho-detalhes .item_largura');

      //Comprimento
      comprimentoProdutoUnitario = formatToNum(row,'.tamanho-detalhes .item_comprimento');

      arrVolumeAux = [{
         peso: pesoProdutoUnitario,
         altura: alturaProdutoUnitario,
         largura: larguraProdutoUnitario,
         comprimento: comprimentoProdutoUnitario,
         tipo: 'string',
         valor: precoUnitario,
         quantidade: inputQtd
      }];

      productInfos['volumes'].push(arrVolumeAux);

      arrProdAux = [{
         peso: pesoProdutoUnitario,
         altura: alturaProdutoUnitario,
         largura: larguraProdutoUnitario,
         comprimento: comprimentoProdutoUnitario,
         tipo: 'string',
         valor: precoUnitario,
         quantidade: inputQtd
      }];

      productInfos['produtos'].push(arrProdAux);

      //Somas
      productInfos['valorTotal'] = productInfos['valorTotal'] + inputValorTotalProduto;
      productInfos['pesoTotal'] = productInfos['pesoTotal'] + pesoTotalProduto;

      productInfos['altura'] = alturaProdutoUnitario;
      productInfos['largura'] = larguraProdutoUnitario;
      productInfos['comprimento'] = comprimentoProdutoUnitario;
   }

   return productInfos;
}

   function formatToNum(row,valor){
      return parseFloat(row.querySelector(valor).getAttribute('data-value'));
   }

   function voltarConsultaFrete(){
   }
/*Fim Funcões Extra para caáulo do frete*/


/*Funções Carregar no Load*/
$(document).ready(function (e){

const firstOption = document.querySelector('#SingleOptionSelector-1 input');

if (firstOption && !firstOption.checked) {
  firstOption.checked = true;
  firstOption.dispatchEvent(new Event('change', { bubbles: true })); // dispara o evento se necessário
}

  

  /*Retorna Produtos*/
  fetch("https://algohits.myshopify.com/api/2023-10/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "0bef28bfdfed87d9fc91352fc2455693"
    },
    body: JSON.stringify({
      query: `
        {
          products(first: 100) {
            edges {
              node {
                title
                handle
                metafields(first: 10) {
                  edges {
                    node {
                      key
                      value
                    }
                  }
                }
              }
            }
          }
        }
      `
    })
  })
  .then(res => res.json())
  .then(data => {
    // Aqui você manipula os produtos
    console.log(data)
  });

  


  
 // Verifica se o parâmetro 'details=true' está na URL
 
      if( $('#shopify-section-template--23468063686968__main').length > 0 ){
           if (window.location.search.includes("details=true")  ||window.location.search.includes("details=1")  ) {
        // Faz scroll para a div com ID especificado
        $('html, body').animate({
            scrollTop: $('#shopify-section-template--23468063686968__main').offset().top - 200
        }, 1000); // 1000ms = 1 segundo para o scroll
      }
    }

  
  //Pega o json das variações de cores
   const coresJson = $("#extra_colors_content").attr("data-json");
   if(coresJson == null || coresJson == undefined || coresJson == ""){
      console.log("sem cores para carregar");
   }else{
      const jsonDataCor = JSON.parse(coresJson);
     console.log(jsonDataCor);
      const itensCor = jsonDataCor[0].itens;
      $(itensCor).each(function(c,cElement){
         //console.log(cElement.cor);
         crAttr = (cElement.cor).toLowerCase();
         htmlVariation = `
             <a class="subtitle pills-variant-labels alignColorVariations" data-color="${crAttr}" href="${cElement.link}">
				${cElement.cor}
			</a>`;
         $(".product-form__controls-group input[name='Cor']").closest(".product-form__controls-group").append(htmlVariation);

         //aplica o atributo também no span
        valorCorProdutoOriginal =  $(".product-form__controls-group input[name='Cor']").val();
        $(".product-form__controls-group input[name='Cor']").closest(".product-form__controls-group").find("label").attr("data-color",valorCorProdutoOriginal.toLowerCase())

      });
   }

  
  
   //Pega o json do guia de tamanhos
   const guiaJson = $("#guia_de_tamanhos_content").attr("data-json");
   const nomeProduto = $("#guia_de_tamanhos_content").attr("data-title");
   const imagemProduto = $("#guia_de_tamanhos_content").attr("data-img");

   if(guiaJson == null || guiaJson == undefined || guiaJson == ""){
      /*Anula e esconde a guia de tamanhos
      1. Percorre os campos de acordeon do produto*/
      $(".product-about").each(function (i,objElement){
           var elementHtmlP = $(objElement).find(".product-about__accordion-description p");
            //Agora perccorre cada um dos parágrafos para verificar se alguma tem o guia
           $(elementHtmlP).each(function (j,pElement){
               // Se tiver o guia, remove a Guia de tamanhosm pois não tem medidas
               if ($(pElement).text() == "[guia de medidas]"){
                  $(objElement).addClass("escondeAba");
               }
           });
      });
   }else{
      //Tem os tamanhos então percorre os itens e monta a tabela
      const jsonData = JSON.parse(guiaJson);

      htmlThs = "";
      var contThs = jsonData[0].headers;
      if(contThs && contThs!="" && contThs!=null){
         contThs = contThs.split(",");
         for (let i = 0; i < contThs.length; i++) {
            let cabecalho = contThs[i].trim(); // Limpa espaços extras
            htmlThs += `<th>${cabecalho}</th>`; // Concatena os elementos <th> à string
         }
      }

      $htmlFullTr = "";
      contTrs = jsonData[0].body;
      if(contTrs && contTrs!="" && contTrs!=null){
         for (let i = 0; i < contTrs.length; i++) {
            HtmlTd = "";
            var contTd = contTrs[i].trim();
            if(contTd && contTd!="" && contTd!=null){
               contTd = contTd.split(",");
               for (let j = 0; j < contTd.length; j++) {
                  let corpo = contTd[j].trim();
                  HtmlTd += `<td>${corpo}</td>`
               }
            }

            $htmlFullTr += `<tr>${HtmlTd}</tr>`;
         }
      }

      htmlTableGuias = "";

      if(imagemProduto != "" && imagemProduto!=undefined && imagemProduto!=null){
         htmlTableGuias +=  '<img className="imgGuia" src="${dataImg}" alt="Guia de tamanhos"/>';
      }

      htmlTableGuias +=`
      <table class="tabela_tamanho">
         <thead>
         <tr>
         ${htmlThs}
         </tr>
         </thead>
         <tbody>
         ${$htmlFullTr}
         </tbody>
      </table>
     `;

      //Com a tabela montada, substitui o guia pelo html da tabela
      $(".product-about").each(function (i,objElement){
         var elementHtmlP = $(objElement).find(".product-about__accordion-description p");
         //Agora perccorre cada um dos parágrafos para verificar se alguma tem o guia
         $(elementHtmlP).each(function (j,pElement){
            // Se tiver o guia, remove a Guia de tamanhosm pois não tem medidas
            if ($(pElement).text() == "[guia de medidas]"){
                //Substitui o conteúdo
               $(pElement).html(htmlTableGuias);
            }
         });
      });
   }
});


/*Script Mascaras*/
function criaMascara(s, r) {
   var t = s.value,
       u = "",
       a = 0,
       b = 0,
       e = "",
       l = !0;
   for (i = 0; i < r.length; i++) "#" != r.substr(i, 1) && (t = t.replace(r.substr(i, 1), ""));
   for (i = 0; i < t.length; i++) isNaN(parseFloat(t.substr(i, 1))) || (u += t.substr(i, 1));
   for (i = 0; i < r.length; i++) "#" == r.substr(i, 1) ? "" != u.substr(a, 1) ? (e += u.substr(a, 1), a++, b++) :
       l = !1 : l && "" != u.substr(a, 1) && (e += r.substr(b, 1), b++);
   s.value = e
}
/*Fim Scripts Máscara*/



